import PropTypes from "prop-types";
import React from "react";
import { statusMetadata } from "./status_metadata";

const StatusBadge = ({ className, label, status }) => {
  const metadata = statusMetadata(status);

  return (
    <span className={`ccw-status ccw-status--${metadata.modifier} ${className}`.trim()}>
      <span aria-hidden="true">{metadata.symbol}</span>
      {label || metadata.label}
    </span>
  );
};

StatusBadge.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  status: PropTypes.string
};

StatusBadge.defaultProps = {
  className: "",
  label: null,
  status: "unmatched"
};

export default StatusBadge;
